import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AccountingBookingSuggestionResource } from "@exonn/js-sdk";

/**
 * Booking suggestions for unassigned bank transactions (S6b). Created by the
 * backend after the payment processors; a person confirms, changes or rejects.
 */
export const module: ModuleOptions<AccountingBookingSuggestionResource> = {
  resource: ResourceEnum.AccountingBookingSuggestion,
  bigIcon: <span className={"icon-20-decision"} />,
  smallIcon: <span className={"icon-15-decision"} />,
  disableCreate: true,
  disableDelete: true,
  tabs: {
    edit: {
      // Der Reiter nennt den Zahlungsempfänger und den Betrag. Der frühere Rückfall auf
      // den Kontotyp zeigte den Systemwert („TelephoneAndInternetExpense“), und der Betrag
      // stand unformatiert daneben.
      getTitle: (resource, t) => {
        const empfaenger = resource.bank_transaction?.remote_name;
        const betrag = resource.bank_transaction?.amount;

        const teile = [
          empfaenger,
          betrag === null || betrag === undefined
            ? null
            : new Intl.NumberFormat("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Number(betrag)),
        ].filter(Boolean);

        return teile.length > 0 ? teile.join(" · ") : t("moduleName");
      },
    },
  },
};
